__turbopack_context__.v({
  "faqContainer": "JpZsDa_faqContainer",
  "faqItem": "JpZsDa_faqItem",
  "faqList": "JpZsDa_faqList",
  "faqTitle": "JpZsDa_faqTitle",
  "faqTitleWrapper": "JpZsDa_faqTitleWrapper",
});
